import { createSelector } from 'reselect';
import creditsSelector from './currentCredits';

export default createSelector(creditsSelector, (credits) =>
    credits.find((credit) => credit.type === 'group_credits' && credit.remainingCredits > 0),
);
